export default __webpack_public_path__ + "media/icons/check-circle-green-43b79651.svg";